import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DominioComercialOrientadoADados from "./sections/DominioComercialOrientadoADados";
import MenuDeTratamentos from "./sections/MenuDeTratamentos";
import ControloTotalDeDados from "./sections/ControloTotalDeDados";
import FuncionalidadesQueGeramResultados from "./sections/FuncionalidadesQueGeramResultados";
import JornadaDoPedido from "./sections/JornadaDoPedido";
import SuaJornadaVipComecaAqui from "./sections/SuaJornadaVipComecaAqui";
import RodapeInstitucional from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <DominioComercialOrientadoADados />
      <MenuDeTratamentos />
      <ControloTotalDeDados />
      <FuncionalidadesQueGeramResultados />
      <JornadaDoPedido />
      <SuaJornadaVipComecaAqui />
      <RodapeInstitucional />
    </div>;
}